<template>
    <div>
        <swiper class="swiper sa-mt15" ref="swiper" :options="swiperOption">
            <swiper-slide v-for="familyList in familyLists" :key="familyList.id">
                <family-patients-profile :familyList="familyList" class="sa-user-list" />
            </swiper-slide>
        </swiper>
        <h5 class="sa-text-center" v-if="!familyLists.length">No data found</h5>
    </div>
</template>

<script>
import {
    family_url
} from "../../../config/endpoints";
import FamilyPatientsProfile from '../familydoctors/FamilyPatientsProfile.vue'
export default {
    components: {
        FamilyPatientsProfile
    },
    data() {
        return {
            familyLists: [],
            swiperOption: {
                slidesPerView: 2,
                spaceBetween: 20,
                breakpoints: {
                    1024: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 1.8,
                    },
                    520: {
                        slidesPerView: 1.3
                    },
                    375: {
                        slidesPerView: 1.1,
                        spaceBetween: 10,
                    },
                    320: {
                        slidesPerView: 1,
                    },
                },
            },

        }
    },
    methods: {
        familyData() {
            let _self = this
            _self.$store.dispatch("httpPost", {
                uri: `${family_url}/subscriber`,
                body: {
                    "channel": "dashboard"
                }
            }).then((response) => {
                if (response && response.status == 1000) {
                    _self.familyLists = response.data
                } else {
                    _self.loader = false
                    _self.$store.dispatch("SET_ALERTMESSAGE", {
                        msg: "Something went wrong",
                        class: "sa-a-danger"
                    });
                }
            })
        }
    },
    mounted() {
        this.familyData()
    },
}
</script>
<style>
.sa-user-list {
    background-color: #F0FFF9;
}
.sa-user-list .sa-fam-patients {
    height: 110px;
}
</style>
